<template>
    <div>
        <p class="label-upgrade">{{ $t('select_to_pay') }}:</p>
        <div v-for="(item, index) in products_list" class="slect-product" :key="index">
            <div v-if="item.feature_code === package_select">
                <input :id="'product_' + item.product_id" name="product_item" type="radio" v-model="product" :value="item.product_id" />
                <label :for="'product_' + item.product_id" class="slect-package d-flex justify-content-between box-shadow-main">
                    <!-- <div class="slect-name"> -->
                        <p>{{ item.product_name ? item.product_name : 'Product Name' }}</p>
                        <!-- <p>{{ item.price | toCommas }} &#8363;</p> -->
                    <!-- </div> -->
                    <!-- <span>{{ item.desc.price_month | toCommas }} / {{ $t('month') }}*</span> -->
                </label>
                <div>
                    <p>{{ item.price | toCommas }} &#8363;</p>
                    <p class="slect-name text-end text-decoration-line-through" v-if="item.original_price && item.original_price > item.price">{{ item.original_price | toCommas }} &#8363;</p>
                </div>
            </div>
        </div>
        <p><b>(*) {{ $t('note') }}:</b> {{ $t('upgrade_prices_differ_on_web_vs_mobile_payments') }}</p>
        <div class="d-flex justify-content-center">
            <div class="btn-payment box-shadow-main btn-payment-change btn-undo" @click="updateStep(1)">{{ $t('back') }}</div>
            <div class="btn-payment box-shadow-main btn-payment-change btn-continue" :class="{ 'disabled': product === '' }" @click="product != '' ? updateStep(3) : ''" :aria-disabled="product === ''">{{ $t('continue_txt') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UpgradeFeatureDetail',
    props: {
        package_select: {
            type: String,
            required: true
        },
        products_list: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            product: ''
        }
    },
    methods: {
        updateStep(step) {
            this.$emit('updateStep', step, this.product, '');
        }
    }
}
</script>

<style scoped>
[type="radio"]:not(:checked),
[type="radio"]:checked {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.slect-product [type=radio]:checked+label.slect-package {
    color: #ffffff;
    background: #e98437;
}

.btn-payment-change {
    margin: 30px 5px;
}

.btn-undo {
    background: #fff;
    color: #212529;
    width: 120px;
}

.btn-continue {
    width: 180px;
}

.btn-payment.disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
}
</style>